import users from './users'
import system from './system'
import dashboard from './dashboard'
// import report from './report'
import contents from './contents'
import orders from './orders'

// Array of sections
export default [...dashboard, ...orders, ...users, ...contents, ...system]
